module.exports = __webpack_public_path__ + "static/media/border-all.46ca9fea.svg";